export default {
    methods: {
        _toArray( v ) {
            if ( !v ) {
                return null;
            }

            if ( Array.prototype.isPrototypeOf(v) ) {
                return v;
            }

            return JSON.parse(v);
        },

        isWide() {
            return document.body.clientWidth > 1368;
        },

        writeToClipboard( _val ) {
            console.log('#8 writeToClipboard, _val=', _val);

            var input = document.createElement("input");
            input.value = _val;

            document.body.appendChild(input);
            input.select();

            document.execCommand("Copy");
            input.remove();
        },

        _textareaAutoHeight(e) {
            var _this = e.target;

            if ( !_this ) {
                // console.log('#40 _textareaAutoHeight', _this, e);
                return;
            }

            if(e.keyCode == 8 || e.keyCode == 46) {
                $(_this).removeAttr('style');
            }

            var scrollH = _this.scrollHeight,
            height = $(_this).outerHeight() - 1;
            if(scrollH > height) {
                $(_this).height(scrollH - 4);
            }
        }
    }
  }


// WEBPACK FOOTER //
// ./src/assets/mixins/AbstractComponent.js